import { axios } from './axios';
import { GetSignedUrlForUploadRequestPayload } from '../store/modules/static-file/types/static-file.types';

export const staticFileApi = {
  async getSignedUrlForUpload(payload: GetSignedUrlForUploadRequestPayload[]) {
    return axios.get('signed-url-for-upload', { params: payload });
  },
};
